export default __webpack_public_path__ + "static/media/algodao_milho.21c45e38.svg";